import { render, staticRenderFns } from "./guarantor.vue?vue&type=template&id=48dccedc&"
import script from "./guarantor.vue?vue&type=script&lang=js&"
export * from "./guarantor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports